import { useTranslation } from 'next-i18next';
import { colors, Logo, spacing, Typography } from '@codility/rondo-ui';
import styled from 'styled-components';

const Header = styled.header`
  background-color: ${colors.white};
  height: var(--header-height);
  padding: 0 ${spacing.spacing32};

  display: flex;
  align-items: center;
`;

const PoweredBy = styled.div`
  display: flex;
  align-items: center;
`;

const PoweredByText = styled(Typography)`
  && {
    font-size: 0.75rem;
    line-height: 0.75rem;
  }
`;

const HostLogo = styled.img`
  height: ${spacing.spacing24};
  margin-right: ${spacing.spacing16};
`;

const CodilityLink = styled.a.attrs({
  href: 'https://www.codility.com/',
  target: '_blank',
  rel: 'noreferrer',
})<{ standalone?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    height: ${({ standalone }) =>
      standalone ? spacing.spacing24 : spacing.spacing16};
    width: auto;
    margin-left: ${spacing.spacing8};
  }
`;

interface Props {
  logo?: string;
  className?: string;
}

export const GlobalHeader = ({ logo, className }: Props) => {
  const { t } = useTranslation('common');

  return (
    <Header className={className}>
      {logo && <HostLogo src={logo} alt="Host logo" />}
      <PoweredBy>
        <PoweredByText>{t('poweredBy')}</PoweredByText>
        <CodilityLink>
          <Logo color="midnight" />
        </CodilityLink>
      </PoweredBy>
    </Header>
  );
};
